module.exports = __webpack_public_path__ + "img/其他费用.7693b395.png";